import { briefTitle } from "@bash/shared";

/**
 * Display title for a creation: caption, else filename, else the first sentence
 * of its brief, else "Untitled". The rule lives in @bash/shared so the server's
 * share reads name a creation the same way.
 */
export { briefTitle, creationTitle } from "@bash/shared";

/** Characters no saved filename may carry (path separators, reserved, control). */
const UNSAFE_NAME = /[\/\\:*?"<>|\u0000-\u001f]+/g;

/**
 * The name a creation downloads under when it carries no filename (generated
 * media): its caption, else its brief's first sentence, made safe for a
 * filename, with the stored object's extension ('bin' is the absence of a type,
 * never stamped). "Creation" when nothing names it: never the storage uuid.
 */
export function creationDownloadName(
  caption: string | null | undefined,
  brief: string | null | undefined,
  storagePath: string
): string {
  const title =
    (caption?.trim() || briefTitle(brief) || "")
      .replace(UNSAFE_NAME, " ")
      .replace(/\s+/g, " ")
      .trim() || "Creation";
  const base = storagePath.split("/").pop() ?? "";
  const dot = base.lastIndexOf(".");
  const ext = dot > 0 ? base.slice(dot + 1).toLowerCase() : "";
  const stamp =
    /^[a-z0-9]{1,8}$/.test(ext) &&
    ext !== "bin" &&
    !title.toLowerCase().endsWith(`.${ext}`);
  return stamp ? `${title}.${ext}` : title;
}
